<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h2 class="mb-4">{{__('lang.shoppingcart.save')}}</h2>
				<div class="form-row">
					<b-form-group
						class="form-group col-12 col-md-6"
						:label="label.configuration_description"
						label-for="configurationdescription"
						label-class="col-form-label col-form-label-sm text-secondary required"
						:invalid-feedback="feedback.configuration_description"
						:state="configurationDescriptionState"
					>
						<b-form-input type="text" class="form-control border" v-model="input.configuration.description" id="configurationdescription" required="required" :state="configurationDescriptionState"></b-form-input>
					</b-form-group>
					<b-form-group
						class="form-group col-12 col-md-6"
						:label="label.configuration_editor"
						label-for="configurationeditor"
						label-class="col-form-label col-form-label-sm text-secondary"
					>
						<b-form-input type="text" class="form-control border" v-model="input.configuration.editor" id="configurationeditor"></b-form-input>
					</b-form-group>
				</div>

				<span v-if="user.auth">
					<div class="form-row"  v-if="configuration == null">
						<div class="form-group col-12">
							<b-form-radio v-model="input.selection" name="save-project-type" value="1">{{__('lang.shoppingcart.save.options.rb0')}}</b-form-radio>
							<b-form-radio v-model="input.selection" name="save-project-type" value="2">{{__('lang.shoppingcart.save.options.rb1')}}</b-form-radio>
							<!-- <b-form-radio v-model="input.selection" name="save-project-type" value="0">{{__('lang.shoppingcart.save.options.rb2')}}</b-form-radio> -->
						</div>
					</div>
					<p class="mb-4" v-if="input.selection == 0 && configuration == null">{{__('lang.shoppingcart.save.project.temporary')}}</p>
					<div class="form-row" v-if="input.selection == 1 && configuration == null">
						<div class="form-group col-12 col-md-6">
							<label class="col-form-label col-form-label-sm required" for="projekt_id">
								{{__('lang.shoppingcart.save.project')}}
							</label>
							<b-form-select class="col-form-label col-form-label-sm" v-model="input.project_id" :options="project_options" id="projekt_id"></b-form-select>
						</div>
					</div>
					<div v-else>
						<ul class="nav nav-pills nav-fill">
							<li class="nav-item">
								<a class="nav-link active" id="basic-tab" href="#save-basic-pane" data-toggle="tab" role="tab" aria-controls="save-basic-pane" aria-selected="true">{{__('lang.shoppingcart.save.project.basicdata')}}</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="contact-tab" href="#save-contact-pane" data-toggle="tab" role="tab" aria-controls="save-contact-pane" aria-selected="false">{{__('lang.shoppingcart.save.project.contact')}}</a>
							</li>
						</ul>
						<div class="tab-content">
							<div class="tab-pane fade show active" id="save-basic-pane" role="tabpanel" aria-labelledby="basic-tab">
								<h4 class="my-4">{{__('lang.shoppingcart.save.project.basicdata')}}</h4>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.project_name"
										label-for="project_name"
										label-class="col-form-label col-form-label-sm text-secondary required"
										:invalid-feedback="feedback.name"
										:state="projectNameState"
									>
										<b-form-input type="text" class="form-control border" v-model="input.name" id="project_name" required="required" :state="projectNameState"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.project_number"
										label-for="project_number"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.number" id="project_number"></b-form-input>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.street"
										label-for="project_street"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.street" id="project_street"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.post_code"
										label-for="project_zip"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.post_code" id="project_zip"></b-form-input>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.city"
										label-for="project_city"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.city" id="project_city"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.country"
										label-for="project_country"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-select class="col-form-label col-form-label-sm text-secondary" v-model="input.country" :options="country_options" id="project_country"></b-form-select>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12"
										:label="label.description"
										label-for="project_description"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<textarea class="form-control border" name="description" v-model="input.description" id="project_description"></textarea>
									</b-form-group>
								</div>
							</div>
							<div class="tab-pane fade" id="save-contact-pane" role="tabpanel" aria-labelledby="contact-tab">
								<h4 class="my-4">{{__('lang.shoppingcart.save.project.contact')}}</h4>

								<div class="form-row">
									<b-form-group class="form-group col-12 col-md-6" :label="__('lang.my_account.form_of_address')" label-for="Salutation" label-class="col-form-label col-form-label-sm text-secondary">
											<b-form-select class="col-form-label col-form-label-sm text-secondary" v-model="input.customer.form_of_address" :options="salutation_options" name="Salutation"></b-form-select>
										</b-form-group>
										<b-form-group
											class="form-group col-12 col-md-6"
											:label="__('lang.my_account.company_name')"
											label-for="Companyname"
											label-class="col-form-label col-form-label-sm text-secondary"
											>
											<b-form-input
												name="Companyname"
												v-model="input.customer.company_name"
												type="text"
												class="form-control border"
											></b-form-input>
										</b-form-group>
								</div>

								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.first_name"
										label-for="contact_firstname"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.first_name" id="contact_firstname" autocomplete="given-name"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.last_name"
										label-for="contact_lastname"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.last_name" id="contact_lastname" autocomplete="family-name"></b-form-input>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.phone"
										label-for="contact_phone"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.phone" id="contact_phone" autocomplete="tel"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.mobil"
										label-for="contact_mobile"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.mobile" id="contact_mobile" autocomplete="tel"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.email"
										label-for="contact_email"
										label-class="col-form-label col-form-label-sm text-secondary"
										invalid-feedback="Email nicht Valide"
										:state="emailState"
									>
										<b-form-input type="email" class="form-control border" v-model="input.customer.email" id="contact_email" autocomplete="email" :state="emailState"></b-form-input>
									</b-form-group>
								</div>
							</div>
						</div>
					</div>
				</span>
				<span v-else>
					<p class="mb-4">{{__('lang.shoppingcart.save.project.temporary')}}</p>
					<div>
						<ul class="nav nav-pills nav-fill">
							<li class="nav-item">
								<a class="nav-link active" id="basic-tab" href="#save-basic-pane" data-toggle="tab" role="tab" aria-controls="save-basic-pane" aria-selected="true">{{__('lang.shoppingcart.save.project.basicdata')}}</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" id="contact-tab" href="#save-contact-pane" data-toggle="tab" role="tab" aria-controls="save-contact-pane" aria-selected="false">{{__('lang.shoppingcart.save.project.contact')}}</a>
							</li>
						</ul>
						<div class="tab-content">
							<div class="tab-pane fade show active" id="save-basic-pane" role="tabpanel" aria-labelledby="basic-tab">
								<h4 class="my-4">{{__('lang.shoppingcart.save.project.basicdata')}}</h4>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.project_name"
										label-for="project_name"
										label-class="col-form-label col-form-label-sm text-secondary required"
										:invalid-feedback="feedback.name"
										:state="projectNameState"
									>
										<b-form-input type="text" class="form-control border" v-model="input.name" id="project_name" required="required" :state="projectNameState"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.project_number"
										label-for="project_number"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.number" id="project_number"></b-form-input>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.street"
										label-for="project_street"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.street" id="project_street"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.post_code"
										label-for="project_zip"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.post_code" id="project_zip"></b-form-input>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.city"
										label-for="project_city"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.city" id="project_city"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.country"
										label-for="project_country"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-select class="col-form-label col-form-label-sm text-secondary" v-model="input.country" :options="country_options" id="project_country"></b-form-select>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12"
										:label="label.description"
										label-for="project_description"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<textarea class="form-control border" name="description" v-model="input.description" id="project_description"></textarea>
									</b-form-group>
								</div>
							</div>
							<div class="tab-pane fade" id="save-contact-pane" role="tabpanel" aria-labelledby="contact-tab">
								<h4 class="my-4">{{__('lang.shoppingcart.save.project.contact')}}</h4>
								<div class="form-row">
									<b-form-group class="form-group col-12 col-md-6" :label="__('lang.my_account.form_of_address')" label-for="Salutation" label-class="col-form-label col-form-label-sm text-secondary">
										<b-form-select class="col-form-label col-form-label-sm text-secondary" v-model="input.customer.form_of_address" :options="salutation_options" name="Salutation"></b-form-select>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="__('lang.my_account.company_name')"
										label-for="Companyname"
										label-class="col-form-label col-form-label-sm text-secondary"
										>
										<b-form-input
											name="Companyname"
											v-model="input.customer.company_name"
											type="text"
											class="form-control border"
										></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.first_name"
										label-for="contact_firstname"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.first_name" id="contact_firstname" autocomplete="given-name"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.last_name"
										label-for="contact_lastname"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.last_name" id="contact_lastname" autocomplete="family-name"></b-form-input>
									</b-form-group>
								</div>
								<div class="form-row">
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.phone"
										label-for="contact_phone"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.phone" id="contact_phone" autocomplete="tel"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.mobil"
										label-for="contact_mobile"
										label-class="col-form-label col-form-label-sm text-secondary"
									>
										<b-form-input type="text" class="form-control border" v-model="input.customer.mobile" id="contact_mobile" autocomplete="tel"></b-form-input>
									</b-form-group>
									<b-form-group
										class="form-group col-12 col-md-6"
										:label="label.email"
										label-for="contact_email"
										label-class="col-form-label col-form-label-sm text-secondary"
										invalid-feedback="invalid Email"
										:state="emailState"
									>
										<b-form-input type="email" class="form-control border" v-model="input.customer.email" id="contact_email" autocomplete="email" :state="emailState"></b-form-input>
									</b-form-group>
								</div>
							</div>
						</div>
					</div>
				</span>
				<div class="form-row my-4">
					<div class="form-group col-12 col-md-6 order-2 order-md-1">
						<button class="btn btn-gray-50 text-white btn-block border-0" type="reset" data-dismiss="modal">
							<svg class="icon">
							<use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
							</svg>
							{{__('lang.btn.cancel')}}
						</button>
					</div>
					<div class="form-group col-12 col-md-6 order-1 order-md-2" v-if="user.auth">
						<button class="btn btn-primary btn-block border-0" type="submit" @click="submitConfiguration">
							<svg class="icon">
						<use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
						</svg>
						 {{__('lang.btn.submit')}}
						</button>
					</div>
					<div class="form-group col-12 col-md-6 order-1 order-md-2" v-else>
						<button class="btn btn-primary btn-block border-0" type="submit" @click="setConfiguration">
							<svg class="icon">
						<use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
						</svg>
						 {{__('lang.btn.submit')}}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import projectApi from './services/api/project'
import configurationApi from './services/api/configuration'

  export default {
	 computed: {
    	configurationDescriptionState() {
			if(!this.attempt_submit) return null
			if(this.input.configuration.description.length >= 255) return false
			return this.input.configuration.description.length >= 1
	    },
		 projectNameState() {
			if(!this.attempt_submit) return null
			if(this.input.name.length >= 255) return false
			return this.input.name.length >= 1
	    },
	    emailState() {
			if(!this.attempt_submit)return null
			if(this.input.customer.email == null || this.input.customer.email == '') return true
			return this.validateEmail(this.input.customer.email)
	    },
    	formData: {
    		get () {
    			return this.$store.state.user.formData
    		},
    	},
		user: {
    		get () {
    			return this.$store.state.user.user
    		},
		    set (value) {
  		      	this.$store.commit('user/updateUser', value)
  		    }
    	},

    	projectData: {
    		get () {
    			return this.$store.state.user.projectData
    		},
		    set (value) {
  		      	this.$store.commit('user/updateProjectData', value)
  		    }
    	},
    	project: {
    		get () {
    			return this.$store.state.projectData.project
    		},
		    set (value) {
  		      	this.$store.commit('projectData/updateProject', value)
  		    }
    	},

    	session: {
    		get () {
    			return this.$store.state.user.session
    		},
    	},
	    update: {
    		get () {
    			return this.$store.state.globalData.update
    		},
		    set (value) {
  		      	this.$store.commit('globalData/updateUpdate', value)
    		}
	    },
	    configuration: {
    		get () {
    			return this.$store.state.user.configuration
    		},
		    set (value) {
  		      	this.$store.commit('user/updateConfiguration', value)
    		}
	    },
      	shoppingcartlist: {
    		 get() {
                return this.$store.state.shoppingcart.shoppingcartlist
              }
		  },
		/* projectTmp: {
			get() {
				return this.$store.state.user.projectTmp
			},
			set(value) {
				this.$store.commit('user/updateProjectTmp', value)
			}
		}, */
    },
    data() {
      return {
    	attempt_submit: false,
        feedback: {
          configuration_description: this.__('lang.shoppingcart.save.invalidfeedback.description'),
          name: this.__('lang.shoppingcart.save.invalidfeedback.project_name'),
        },
        label: {
          configuration_description: this.__('lang.shoppingcart.save.description'),
          configuration_editor: this.__('lang.shoppingcart.save.editor'),
          project_name: this.__('lang.shoppingcart.save.project.name'),
          project_number: this.__('lang.shoppingcart.save.project.number'),
          street: this.__('lang.shoppingcart.save.project.street'),
          post_code: this.__('lang.shoppingcart.save.project.zip'),
          city: this.__('lang.shoppingcart.save.project.city'),
          country: this.__('lang.shoppingcart.save.project.country'),
          description: this.__('lang.shoppingcart.save.project.description'),
          first_name: this.__('lang.shoppingcart.save.project.contact.firstname'),
          last_name: this.__('lang.shoppingcart.save.project.contact.lastname'),
          phone: this.__('lang.shoppingcart.save.project.contact.phone'),
          mobil: this.__('lang.shoppingcart.save.project.contact.mobile'),
		  email: this.__('lang.shoppingcart.save.project.contact.email'),

        },
        input:{
          selection: 2,
          project_id: null,
          option: null,
          id: null,
          name: '',
          number: '',
          street: '',
          post_code: '',
          city: '',
          country: 'deu',
          description: '',
          configuration: {
            id: null,
            description: '',
            editor: '',
          },
          customer: {
            id: null,
            type: 0,
            first_name: '',
            last_name: '',
            phone: '',
            mobile: '',
			email: '',
			form_of_address:'',
			company_name:''

			}
        },
        project_options: [],
        country_options: [],
		validation: null,
		salutation_options: [],
      }
    },
	methods: {
		setData: function () {
			var contact_index


			//this.input = { ...this.input, ...JSON.parse(JSON.stringify(this.project)) }
            console.log('setData this.input2:');
            console.log(this.input);



			//this.input = JSON.parse(JSON.stringify(this.project))


			//this.input.configuration = Object.assign({}, this.user.configuration)
			 /*
			 console.log('WKSave setData this.user.ProjectTmp:');
			console.log(this.projectTmp);
			if (this.projectTmp != 'undefined' && this.projectTmp != null) this.input = Object.assign({}, this.projectTmp)  */
            console.log('this.formData.countries:')
            console.log(this.formData.countries)

			this.country_options = this.setInputLabels(this.formData.countries)
			this.salutation_options = [
				{ value: '1', text: this.__('lang.newsletter.modal.input.salutation.option.male') },
				{ value: '2', text: this.__('lang.newsletter.modal.input.salutation.option.female') },
				{ value: '5', text: this.__('lang.newsletter.modal.input.salutation.option.divers') }
			]
			this.salutation_options.unshift({
				value: null,
				text: this.__("lang.my_account.select.choose"),
				disabled: true,
			});

			if (this.projectData.length > 0){
				this.project_options = []
				this.input.customer = {}
				this.projectData.forEach(function (proj) {
					/*
					contact_index = proj.contacts.findIndex(contact => contact.type == 1)
					if (contact_index >= 0) this.input.customer = proj.contacts[contact_index]
					//else this.project.contacts.push(this.inputContact)
					*/
					this.project_options.push({
						value: proj.id, text: proj.name
					})
				}.bind(this))
			}
    	},
		setConfiguration: function(){
			this.attempt_submit = true
			console.log('setConfiguration this.input:')
			console.log(this.input)
			if(this.configurationDescriptionState && this.projectNameState){
				this.project = Object.assign( {}, this.input);
				console.log('setConfiguration this.project:')
				console.log(this.project)
				//this.$store.commit('user/updateProjectTmp', this.input)
				document.getElementById('closeModalSave').click();
			}
		},
		submitConfiguration: function(){
			console.log('submitConfiguration')
			this.validation = null
			this.attempt_submit = true

			if(this.input.selection == "2" && this.projectNameState && this.configurationDescriptionState && this.emailState){
				this.validation = "1"
			}
			if(this.input.selection == "1" && this.input.project_id && this.configurationDescriptionState && this.emailState){
				this.validation = "1"
			}

			if(this.validation == 1 && (this.input.selection == "2" || this.input.selection == "1")){
				this.attempt_submit = false
				this.project =  Object.assign({}, this.input);
				this.saveConfiguration()
				document.getElementById('closeModalSave').click();
			//--	document.getElementById('closeProjectModal').click();
			}
			if(this.configurationDescriptionState && this.projectNameState && this.input.selection == "0"){
				this.attempt_submit = false
				this.project = Object.assign({}, this.input);
				console.log(this.project)
				document.getElementById('closeModalSave').click();
			//--	document.getElementById('closeProjectModal').click();
			}
		},
		updateConfiguration() {
			console.log('updateConfiguration this.project: ')
			console.log(this.project)
			this.input = JSON.parse(JSON.stringify(this.project))
			this.input.customer = this.input.contacts.filter(contact=>contact.type==1)[0] //ToDo: contacts sturcture????

			this.country_options = this.setInputLabels(this.formData.countries)
			this.project_options = []
			this.projectData.forEach(function(e){
				this.project_options.push({
					value: e.id, text: e.name
				})
			}.bind(this))
			this.saveConfiguration()
		},
		async saveConfiguration(){
			var body = {}
			body['user'] = this.session
			if(this.configuration !== null){
				var configuration = {
					id: this.configuration.id,
					service_id:  this.configuration.service_id,
					description: this.configuration.description,
			      	version: this.configuration.formula_version,
					editor: this.configuration.editor,
				}
				var body = await this.getBody(configuration)
				var configResponse = await configurationApi.createConfiguration(body);
			  	console.log('saveConfiguration this.configuration !== null configResponse:')
			  	console.log(configResponse)
				if(configResponse.status >= 400){
   					this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
   					return
				}

               console.log('saveConfiguration this.projectData:')
                console.log( this.projectData)


                console.log('saveConfiguration this.projectData:')
                console.log( this.projectData)


                this.project.configuration.id = this.configuration.service_id

                //var project = this.projectData.find(projects => projects.configurations.id == this.configuration.service_id);




                var project =  this.projectData.find((obj) => {
                    if (obj.configurations) {
                        return obj.configurations.some((config) => config.id === this.configuration.service_id);
                    }
                    return false;
                });


                if (project) {
                    body['project'] = project
                    var projectResponse = await projectApi.updateProject(body);

                    console.log('saveConfiguration body:')
                    console.log(body)

                    console.log('  if (project) saveConfiguration project:')
                    console.log(project)


                    //this.setLoadedProject(project, configuration, project.contacts[0])
                    if (typeof project.contacts != 'undefined' && project.contacts.length > 0) {
                        this.setLoadedProject(project, configuration, project.contacts[0])
                    } else {
                        var customer = this.input.customer ? this.input.customer : {}
                        this.setLoadedProject(project, configuration, customer)
                    }
                } else {
                    console.log("project not found");
                }
			}
			else if(this.input.selection == 1){
				console.log('saveConfiguration selection = 1 this.input:')
				console.log(this.input)

				body['configuration'] = {
					project_id:  parseInt(this.input.project_id),
			 	  	description: this.input.configuration.description,
					editor: this.input.configuration.editor,
			      	status: 0,
			      	version: null,
				}
	  			var response = await projectApi.createConfiguration(body);  // create configuration in local database
				console.log('saveConfiguration response createConfiguration:')
				console.log(response)
				if(response.status >= 400) {
   					this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
				}
				if(response.status == 200){
					var configuration = {
						service_id:  response.data.id,
					    description: this.input.configuration.description,
  				    	editor: this.input.configuration.editor,
	           			status: 0,
		        		version: null,
					}
					var body = await this.getBody(configuration)
					var configResponse = await configurationApi.createConfiguration(body);
					this.configuration = configResponse.data
					var project = this.projectData.find(projects => projects.id == this.input.project_id);
					console.log('saveConfiguration response.status == 200:')
					console.log(project)
					//--this.setLoadedProject(project, configuration, project.contacts[0])
					if (typeof project.contacts != 'undefined' && project.contacts.length > 0) {
						this.setLoadedProject(project, configuration, project.contacts[0])
					} else {
						var customer=this.input.customer?this.input.customer:{}
						this.setLoadedProject(project, configuration, customer)
					}
				}
			}
			else{
				body['project'] = this.input
        		console.log('saveConfiguration else body:')
			  	console.log(body)
	  			var projectResponse = await projectApi.createProject(body);
				console.log('saveConfiguration  projectResponse')
				console.log(projectResponse)
				if(projectResponse.status >= 400){
   					this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
   					return
				}
				if(projectResponse.status == 200){
					body['configuration'] = {
						project_id:  projectResponse.data.id,
						description: this.input.configuration.description,
						editor: this.input.configuration.editor,
			      		status: 0,
			      		version: null,
					}
		  			var confResponse = await projectApi.createConfiguration(body);
					if(confResponse.status == 200){
						this.getUserProject()
						var configuration = {
							service_id:  confResponse.data.id,
							description: this.input.configuration.description,
							editor: this.input.configuration.editor,
					     	status: 0,
					     	version: null,
						}

						var body = await this.getBody(configuration)
			  			var configResponse = await configurationApi.createConfiguration(body);
						console.log('createConfiguration configResponse')
						console.log(configResponse)
						if(configResponse.status >= 400){
		   					this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
		   					return
						}
						this.configuration = configResponse.data
            			console.log('this.projectData:')
						console.log(this.projectData)
						console.log(projectResponse.data.id)
						var project = projectResponse.data //this.projectData.find(projects => projects.id == projectResponse.data.id);

						/*--this.setLoadedProject(project, configuration, project.contacts[0])
						if (typeof project.contacts != 'undefined' && project.contacts.length > 0) {
							this.setLoadedProject(project, configuration, project.contacts[0])
						} else {
							var customer=this.input.customer?this.input.customer:{}
							this.setLoadedProject(project, configuration, customer)
						}*/


						if (typeof project.contact != 'undefined') {
							this.setLoadedProject(project, configuration, project.contact)
						} else {
							var customer=this.input.customer?this.input.customer:{}
							this.setLoadedProject(project, configuration, customer)
						}

					}
					else {
	   					this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
					}
				}
				else {
   					this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.kwl.alert.store_configuration_faild')})
				}
			}
			this.$store.dispatch('alert/setAlert', {type: 'success', message: this.__('lang.kwl.alert.store_configuration_success')})
		    this.update.configuration = 1
		    console.log('saveconfiguration end')


		},
		setLoadedProject(project, configuration, customer) {
            console.log('setLoadedProject project:')
            console.log(project)

            console.log('setLoadedProject configuration:')
            console.log(configuration)

            console.log('setLoadedProject customer:')
            console.log(customer)



            this.input = {
                selection: 1,
                project_id: project.id,
                option: project.id,
                id: project.id,
                name: project.name,
                number: project.number,
                street: project.street,
                post_code: project.post_code,
                city: project.city,
                country: project.country,
                description: project.description,
                configuration: {
                    description: configuration.description,
                    editor: configuration.editor,
                },
                customer: customer
            }
            console.log('setLoadedProject input:')
            console.log(this.input)

            this.project = Object.assign(this.project,this.input)
            console.log('setLoadedProject this.project:')
            console.log(this.project)

        },
		getBody(configuration){
			var body = {}
			body['configuration'] = configuration
			body['shoppingcart']  = this.shoppingcartlist
			body['countries_id'] = this.user.countries_id //? 05.11.2021
			console.log('getBody body:')
			console.log(body)
			return body
		},
		async getUserProject() {
			console.log('getUserProject response')
			var response = await projectApi.returnFullProjectData(this.session);
			console.log(response)
			if(response == 404){
				this.projectData = []
			}else if(response >= 404){
				this.error = response;
			}else{
				this.projectData = response
			}
		},
		closeLogin(){
			this.needLogin = false
		},
		setInputLabels: function(value){
			value.forEach(function(item){
				if(item.hasOwnProperty('text')){
					item.text = this.__(item.text)
				}
				if(item.hasOwnProperty('name')){
					item['text'] = this.__(item.name)
				}
				if(item.hasOwnProperty('label')){
					item.label = this.__(item.label)
				}
                if(item.hasOwnProperty('alpha3')){
                  item.value = this.__(item.alpha3)
                }
			}.bind(this))
			return value;
		},
		validateEmail(email)
	    {
	        var re = /\S+@\S+\.\S+/;
	        return re.test(email);
	    }
	},

	created() {

    }
  }
</script>
